import { IV, KEY } from './constants';

export default async function generateEncryptedToken(phone: string) {
  const content = `${phone}:${Date.now()}`;
  return await encrypt(content);
}

async function encrypt(content: string) {
  // To encode strings into bytes using UTF-8 encoding
  const encoder = new TextEncoder();
  const messageBytes = encoder.encode(content);
  const secretKeyBytes = encoder.encode(KEY);
  const ivBytes = encoder.encode(IV);

  // Import the secret key
  const secretKey = await crypto.subtle.importKey('raw', secretKeyBytes, { name: 'AES-CBC', length: 128 }, false, [
    'encrypt',
    'decrypt',
  ]);

  // Encrypt the message
  // For AES-CBC, PKCS7 padding is used by default.
  const ciphertext = await crypto.subtle.encrypt({ name: 'AES-CBC', iv: ivBytes }, secretKey, messageBytes);

  // Convert the ciphertext to a string
  const ciphertextBytes = new Uint8Array(ciphertext);
  const ciphertextString = Array.from(ciphertextBytes)
    .map((byte) => String.fromCharCode(byte))
    .join('');

  return btoa(ciphertextString);
}
